import store from '@/state/store'
import { Helper } from '@/mixin/helper'

import * as Address from '@/services/rest-api/lib/delivery/address'

const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']
let customFeature = {}

function hasRemoveValidationBackDateMgm() {
  const data = getFeatureFlagValue('customFeature.mgm')
  customFeature.mgm = data
  return Array.isArray(data?.company_id) && data.company_id.includes(Helper.methods.getCompanyId())
}

function getExpectedPickupValidation() {
  return hasRemoveValidationBackDateMgm() ? 'bail|optional' : 'bail|optional|timeGteNow'
}

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const enterField = (t, key, fallback) =>
  `${translate(t, 'global.form.enter', 'Masukkan')} ${translate(t, key, fallback)}`

const getDateLang = (t) => ({
  formatLocale: {
    weekdaysMin: [
      translate(t, 'global.days.mon', 'Sen'),
      translate(t, 'global.days.tue', 'Sel'),
      translate(t, 'global.days.wed', 'Rab'),
      translate(t, 'global.days.thu', 'Kam'),
      translate(t, 'global.days.fri', 'Jum'),
      translate(t, 'global.days.sat', 'Sab'),
      translate(t, 'global.days.sun', 'Min'),
    ],
  },
})

const getAddressTableFields = (t) => [
  {
    label: translate(t, 'master.form.address.name', 'Nama Lokasi'),
    key: 'name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.category', 'Kategori Alamat'),
    key: 'category',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.fullAddress', 'Alamat Lengkap'),
    key: 'full_name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.province', 'Provinsi'),
    key: 'province',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: translate(t, 'master.form.address.city', 'Kota'),
    key: 'city',
    isSortable: true,
    isRedirectable: true,
  },
]

export const getOriginFields = (t) => [
  {
    name: 'origin_address_id',
    showKey: 'origin_address',
    type: 'value-help-v2',
    label: translate(t, 'delivery.fields.originAddress', 'Alamat Asal'),
    placeholder: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    validation: 'required',
    trackBy: 'id',
    getInitialObject: (obj) => obj?.origin_address_id,
    displayedBy: 'name',
    listGetter: Address.get(),
    tableFields: getAddressTableFields(t),
    gridColSpan: 2,
  },
  {
    key: 'expected_pickup_on',
    name: 'expected_pickup_on',
    label: translate(t, 'delivery.fields.estimatedPicked', 'Target Diambil'),
    placeholder: translate(t, 'global.action.selectDate', 'Pilih Tanggal'),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    validation: getExpectedPickupValidation(),
    validationMessages: {
      timeGteNow: translate(
        t,
        'delivery.validation.estimatedPickedAfterToday',
        'Target Diambil tidak boleh kurang dari hari Ini'
      ),
    },
    format: 'DD MMM YYYY HH:mm',
    showSecond: false,
    confirm: true,
    confirmText: translate(t, 'global.action.apply', 'Terapkan'),
    lang: getDateLang(t),
  },
  {
    key: 'shipment_number',
    name: 'shipment_number',
    label: translate(t, 'delivery.fields.shipmentNumber', 'No. Shipment'),
    placeholder: enterField(t, 'delivery.fields.shipmentNumber', 'No. Shipment'),
    type: 'text',
    validation: 'bail|max:100,length',
    isShown: true,
  },
  {
    key: 'reference_number',
    name: 'reference_number',
    label: translate(t, 'delivery.fields.referenceNumberText', 'No. Referensi'),
    placeholder: enterField(t, 'delivery.fields.referenceNumberText', 'No. Referensi'),
    type: 'text',
    validation: 'bail|max:100,length',
    isShown: true,
  },
]

export const getDestinationFields = (t) => [
  {
    name: 'destination_address_id',
    showKey: 'destination_address',
    type: 'value-help-v2',
    label: translate(t, 'delivery.fields.destinationAddress', 'Alamat Tujuan'),
    placeholder: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    validation: 'required',
    trackBy: 'id',
    getInitialObject: (obj) => obj?.destination_address_id,
    displayedBy: 'name',
    listGetter: Address.get(),
    tableFields: getAddressTableFields(t),
    gridColSpan: 2,
  },
  {
    key: 'expected_delivered_on',
    name: 'expected_delivered_on',
    label: translate(t, 'delivery.fields.estimatedDelivered', 'Target Terkirim'),
    placeholder: translate(t, 'global.action.selectDate', 'Pilih Tanggal'),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    validation: 'bail|optional|timeGteNow|timeGteField:expected_pickup_on',
    validationMessages: {
      timeGteNow: translate(
        t,
        'delivery.validation.estimatedDeliveredAfterToday',
        'Target Terkirim tidak boleh kurang dari hari Ini'
      ),
      timeGteField: translate(
        t,
        'delivery.validation.estimatedDeliveredAfterPickup',
        'Target Terkirim tidak boleh kurang dari Target Diambil'
      ),
    },
    format: 'DD MMM YYYY HH:mm',
    showSecond: false,
    confirm: true,
    confirmText: translate(t, 'global.action.apply', 'Terapkan'),
    lang: getDateLang(t),
  },
]